import { Button } from "antd";
import "./style.scss";

export default function ButtonSuscribete({clase}) {
    return (
        <div id="id_container_btn_suscribete">
        </div>
    );
}